import React from "react";
import DesignBuildContent from "./designBuildContent";
import Tabs from "../components/Tabs";
import SearchCard01 from "./img/src-design01.png";
import SearchCard02 from "./img/src-design02.png";
import SearchCard03 from "./img/src-design03.png";
import SearchCard04 from "./img/src-design04.png";
import SearchCard05 from "./img/src-design05.png";
import SearchTemplate from "./img/src-template.png";

function DesignBuildSection() {
	return (
		<>
			<section className="content-block" id={DesignBuildContent.id01}>
				<h4 className="section-title-meta"> {DesignBuildContent.meta} </h4>
				<h3 className="section-title"> {DesignBuildContent.titleCard} </h3>
				{DesignBuildContent.parasCard.map((p) => {
					return <p>{p}</p>;
				})}
			</section>

			<section className="figure-block search-card-design">
				<span className="inner">
					<Tabs>
						<div label="design01">
							<ol className="captions-list">
								{DesignBuildContent.captions01.map((li) => {
									return <li className="caption">{li}</li>;
								})}
							</ol>
							<figure className="screen card01">
								<i data-dot="1"></i>
								<i data-dot="2"></i>
								<i data-dot="3"></i>
								<img src={SearchCard01} alt={DesignBuildContent.img01alt} />
							</figure>
						</div>
						<div label="design02">
							<ol className="captions-list">
								{DesignBuildContent.captions02.map((li) => {
									return <li className="caption">{li}</li>;
								})}
							</ol>
							<figure className="screen card02">
								<i data-dot="1"></i>
								<i data-dot="2"></i>
								<i data-dot="3"></i>
								<img src={SearchCard02} alt={DesignBuildContent.img02alt} />
							</figure>
						</div>
						<div label="design03">
							<ol className="captions-list">
								{DesignBuildContent.captions03.map((li) => {
									return <li className="caption">{li}</li>;
								})}
							</ol>
							<figure className="screen card03">
								<i data-dot="1"></i>
								<i data-dot="2"></i>
								<img src={SearchCard03} alt={DesignBuildContent.img03alt} />
							</figure>
						</div>
						<div label="design04">
							<ol className="captions-list">
								{DesignBuildContent.captions04.map((li) => {
									return <li className="caption">{li}</li>;
								})}
							</ol>
							<figure className="screen card04">
								<i data-dot="1"></i>
								<img src={SearchCard04} alt={DesignBuildContent.img04alt} />
							</figure>
						</div>
						<div label="design05">
							<ol className="captions-list">
								{DesignBuildContent.captions05.map((li) => {
									return <li className="caption">{li}</li>;
								})}
							</ol>
							<figure className="screen card05">
								<i data-dot="1"></i>
								<i data-dot="2"></i>
								<i data-dot="3"></i>
								<img src={SearchCard05} alt={DesignBuildContent.img05alt} />
							</figure>
						</div>
					</Tabs>
				</span>
			</section>
			<section className="content-block" id={DesignBuildContent.id02}>
				<h3 className="section-title"> {DesignBuildContent.titleTemplate} </h3>
				{DesignBuildContent.parasTemplate.map((p) => {
					return <p>{p}</p>;
				})}
			</section>
			<section className="figure-block search-template-design">
				<span className="inner">
					<ol className="captions-list">
						{DesignBuildContent.captionsTemplate.map((li) => {
							return <li className="caption">{li}</li>;
						})}
					</ol>
					<figure className="screen">
						<i data-dot="1"></i>
						<i data-dot="2"></i>
						<i data-dot="3"></i>
						<i data-dot="4"></i>
						<i data-dot="5"></i>
						<img src={SearchTemplate} alt={DesignBuildContent.imgTemplateAlt} />
					</figure>
				</span>
			</section>
		</>
	);
}

export default DesignBuildSection;
